import React from 'react';
import { Link } from 'react-router-dom';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import EducationalDisclaimer from '@/components/feature/EducationalDisclaimer';

const NevadaSpecialtyPlatesPage: React.FC = () => (
  <div className="min-h-screen bg-white">
    <Header />
    <section className="pt-28 pb-12 bg-obsidian-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center space-x-2 text-sm text-obsidian-400 mb-4">
          <Link to="/" className="hover:text-gold-400">Home</Link>
          <i className="ri-arrow-right-s-line"></i>
          <Link to="/nevada-dmv-info" className="hover:text-gold-400">DMV Info</Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-gold-400">Specialty License Plates</span>
        </div>
        <h1 className="font-display text-4xl font-bold text-white mb-3">Nevada Specialty License Plates</h1>
        <p className="text-obsidian-300">Information about Nevada&apos;s specialty and charitable license plate programs.</p>
      </div>
    </section>
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <EducationalDisclaimer />
      <div className="space-y-8 text-obsidian-700">
        <section>
          <h2 className="font-display text-2xl font-bold text-obsidian-900 mb-4">What Are Specialty Plates?</h2>
          <p>Nevada offers a wide variety of specialty license plates that support charitable organizations, state programs, and various causes. A portion of the fees collected goes directly to the associated organization or cause.</p>
        </section>
        <section>
          <h2 className="font-display text-2xl font-bold text-obsidian-900 mb-4">Specialty Plate Fees</h2>
          <div className="bg-obsidian-50 rounded-xl p-6">
            <table className="w-full text-sm">
              <thead><tr className="border-b border-obsidian-200"><th className="text-left py-2 font-semibold text-obsidian-900">Fee Type</th><th className="text-right py-2 font-semibold text-obsidian-900">Amount</th></tr></thead>
              <tbody className="divide-y divide-obsidian-100">
                {[['Initial Specialty Plate Fee', '$61.00'], ['Annual Renewal Fee', '$30.00'], ['Standard Registration Fees', 'Still apply in addition to specialty fees'], ['Personalized Specialty Plate (initial)', '$96.00 + specialty fee'], ['Personalized Specialty Plate (renewal)', '$50.00 + specialty fee']].map(([l, a]) => (
                  <tr key={l}><td className="py-2.5 text-obsidian-700">{l}</td><td className="py-2.5 text-right font-medium text-obsidian-900">{a}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
        </section>
        <section>
          <h2 className="font-display text-2xl font-bold text-obsidian-900 mb-4">Popular Specialty Plate Categories</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {[
              { title: 'Wildlife & Environment', desc: 'Plates supporting Nevada wildlife conservation, wild horses, and environmental programs.' },
              { title: 'Education', desc: 'Plates benefiting Nevada schools, universities, and educational programs.' },
              { title: 'Veterans & Military', desc: 'Plates honoring various branches of service and military organizations.' },
              { title: 'Sports Teams', desc: 'Plates featuring Nevada sports teams and athletic programs.' },
              { title: 'Health & Awareness', desc: 'Plates supporting health causes like cancer research and awareness programs.' },
              { title: 'Nevada Pride', desc: 'Plates celebrating Nevada history, culture, and landmarks.' },
            ].map(item => (
              <div key={item.title} className="border border-obsidian-100 rounded-lg p-4">
                <p className="font-semibold text-obsidian-900 text-sm mb-1">{item.title}</p>
                <p className="text-obsidian-500 text-xs">{item.desc}</p>
              </div>
            ))}
          </div>
        </section>
        <section>
          <h2 className="font-display text-2xl font-bold text-obsidian-900 mb-4">How to Order</h2>
          <p className="text-sm">Specialty plates can be ordered through the Nevada DMV website, at a DMV office, or through an authorized third-party provider. Some specialty plates may have minimum order requirements before they are produced.</p>
          <a href="https://dmv.nv.gov/plates" target="_blank" rel="noopener noreferrer nofollow" className="inline-flex items-center space-x-2 mt-3 text-gold-600 hover:text-gold-700 text-sm font-semibold">
            <span>View All Nevada Specialty Plates at dmv.nv.gov</span><i className="ri-external-link-line"></i>
          </a>
        </section>
        <div className="bg-gold-50 border border-gold-200 rounded-xl p-6 text-center">
          <h3 className="font-display font-bold text-obsidian-900 text-lg mb-2">Want Specialty Plates?</h3>
          <p className="text-obsidian-600 text-sm mb-4">Speedy DMV Services can help you order and obtain specialty license plates in Nevada.</p>
          <Link to="/appointment" className="inline-block bg-gold-gradient text-obsidian-900 px-6 py-2.5 rounded-lg font-bold text-sm hover:brightness-110 transition-all whitespace-nowrap">Book Appointment</Link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
);

export default NevadaSpecialtyPlatesPage;
